module.exports = __webpack_public_path__ + "img/icono-nuevomensaje.ef484e2a.svg";